import BaseAPI from "../api";

const path: string = "files";

export class FilesApi extends BaseAPI {
  static createFile(file: FormData): Promise<any> {
    return this.api
      .post(`${path}`, file, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res);
  }
  static getFile(idFile: number): Promise<any> {
    return this.api
      .get(`${path}/${idFile}`, { responseType: "arraybuffer" })
      .then((res) => res);
  }
  static getViewFile(idFile: number): Promise<any> {
    return this.api.get(`${path}/${idFile}/view`).then((res) => res);
  }
}
